// session
import { sessionItem } from "./session";
const Token = "ACCESS-Token";
const User = "USERNAME";
const TeanantId="TenantId";
const TenanName = "TenantName";
// 设置session
export function setToken(val = "") {
  return sessionItem.set(Token, val);
}
export function getToken() {
  return sessionItem.get(Token);
}
export function removeToken() {
  // console.log(Token);
  return sessionItem.remove(Token);
}
export function setName(val = "") {
  return sessionItem.set(User, val);
}
export function getName() {
  return sessionItem.get(User);
}
export function removeName() {
  return sessionItem.remove(User);
}

export function setTenantId(val = "") {
  return sessionItem.set(TeanantId, val);
}
export function getTenantId() {
  return sessionItem.get(TeanantId);
}
export function removeTenantId() {
  return sessionItem.remove(TeanantId);
}
export function setTenantName(val = "") {
  return sessionItem.set(TenanName, val);
}
export function getTenantName() {
  return sessionItem.get(TenanName);
}
export function removeTenantName() {
  return sessionItem.remove(TenanName);
}
export function setSetFreeOpenGate(val) {
  return sessionItem.set('setSetFreeOpenGate', val);
}
export function setRoleCode(val) {
  return sessionItem.set('roleCode', val);
}
export function getRoleCode() {
  return sessionItem.get('roleCode');
}
export function removeRoleCode() {
  return sessionItem.remove('roleCode');
}
export function setUserId(val) {
  return sessionItem.set('userId', val);
}
export function getUserId() {
  return sessionItem.get('userId');
}
export function removeUserId() {
  return sessionItem.remove('userId');
}
export function setLoginSentryId(val) {
  return sessionItem.set('loginSentryId', val);
}
export function getLoginSentryId() {
  return sessionItem.get('loginSentryId');
}
export function removeLoginSentryId() {
  return sessionItem.remove('loginSentryId');
}
export function setChargingPopUp(val) {
  return sessionItem.set('chargingPopUp', val);
}
export function getChargingPopUp() {
  return sessionItem.get('chargingPopUp');
}
export function removeChargingPopUp() {
  return sessionItem.remove('chargingPopUp');
}
export function setOutGateId(val) {
  return sessionItem.set('OutGateId', val);
}
export function getOutGateId() {
  return sessionItem.get('OutGateId');
}
export function removeOutGateId() {
  return sessionItem.remove('OutGateId');
}
export function setLastLoginTime(val) {
  return sessionItem.set('lastLoginTime', val);
}
export function getLastLoginTime() {
  return sessionItem.get('lastLoginTime');
}
export function removeLastLoginTime() {
  return sessionItem.remove('lastLoginTime');
}
export function setIsSentryBoxTabs(val) {
  return sessionItem.set('isSentryBoxTabs', val);
}
export function getIsSentryBoxTabs() {
  return sessionItem.get('isSentryBoxTabs');
}
export function removeIsSentryBoxTabs() {
  return sessionItem.remove('isSentryBoxTabs');
}
